import tempPic from "./../../../../../asset/image/default.png";
import { useTranslation } from "react-i18next";

export default function User({ data, selectedMembers, setSelectedMembers }) {
    const { t } = useTranslation();

    const checkBoxHandle = () => {
        if (!selectedMembers.includes(data.id)) {
            setSelectedMembers([...selectedMembers, data.id]);
        } else {
            setSelectedMembers(
                selectedMembers.filter((item) => item !== data.id)
            );
        }
    };

    return (
        <div
            className="table-row"
            style={
                selectedMembers.includes(data.id)
                    ? { background: "#F1F5FF" }
                    : {}
            }
            onClick={checkBoxHandle}
        >
            <div>
                <div
                    className={
                        selectedMembers.includes(data.id) ? "selected" : ""
                    }
                >
                    <div></div>
                </div>
            </div>
            <div>
                <div>
                    <img src={tempPic} alt="temporary" />
                </div>
                <div>
                    <div>
                        {selectedMembers.includes(data.id)
                            ? t(
                                  "Src.Pages.CustomerClub.Components.ContentManagment.ShareContent.User.Active"
                              )
                            : t(
                                  "Src.Pages.CustomerClub.Components.ContentManagment.ShareContent.User.DeActive"
                              )}
                    </div>
                    <div>
                        {data?.user.first_name + " " + data?.user.last_name}
                    </div>
                </div>
            </div>
        </div>
    );
}
